/**
 * Custom announcement bar: cycles through the promotions that have
 * richtext content (up to 3, from the section's own theme editor
 * settings - never hardcoded) via arrows and/or autorotate. Each
 * promotion's content is already-formatted HTML from Shopify's own
 * richtext editor (bold/italic/links/multiple <p> lines), so it's
 * swapped in via innerHTML rather than rebuilt from separate
 * heading/message/link fields - that's also why it's safe to trust as
 * markup: it's merchant-authored theme-editor content, the same trust
 * level as any other Liquid section setting, not customer input. The
 * initial (index 0) promotion is already server-rendered in
 * sections/custom-announcement-bar.liquid for a correct, no-JS first
 * paint; this only takes over from there.
 */
(function () {
  'use strict';

  function initAnnouncementBar(bar) {
    if (bar.dataset.announcementInitialized === 'true') return;
    bar.dataset.announcementInitialized = 'true';

    var dataEl = bar.querySelector('[data-announcement-data]');
    var promos = [];
    if (dataEl) {
      try {
        promos = JSON.parse(dataEl.textContent) || [];
      } catch (e) {
        promos = [];
      }
    }
    if (!promos.length) return;

    var viewport = bar.querySelector('[data-announcement-viewport]');
    var prevBtn = bar.querySelector('[data-announcement-prev]');
    var nextBtn = bar.querySelector('[data-announcement-next]');
    var pauseBtn = bar.querySelector('[data-announcement-pause]');
    var iconPause = pauseBtn ? pauseBtn.querySelector('[data-icon-pause]') : null;
    var iconPlay = pauseBtn ? pauseBtn.querySelector('[data-icon-play]') : null;

    var activeIndex = 0;
    var rotationMs = parseInt(bar.dataset.rotationMs, 10) || 5000;
    var wantsAutorotate = bar.dataset.autorotate === 'true' && promos.length > 1;
    var timer = null;
    var playing = false;

    function render() {
      var promo = promos[activeIndex];
      if (!promo || !viewport) return;
      viewport.innerHTML = promo.content || '';
      viewport.style.fontSize = promo.font_size ? promo.font_size + 'px' : '';
      viewport.style.fontWeight = promo.font_weight || '';
      viewport.style.color = promo.color || '';
    }

    function goTo(index) {
      activeIndex = (index + promos.length) % promos.length;
      render();
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (wantsAutorotate) {
        timer = setInterval(function () {
          goTo(activeIndex + 1);
        }, rotationMs);
      }
    }

    function setPlaying(isPlaying) {
      playing = isPlaying && wantsAutorotate;
      if (playing) {
        start();
      } else {
        stop();
      }
      if (iconPause) iconPause.hidden = !playing;
      if (iconPlay) iconPlay.hidden = playing;
      if (pauseBtn) {
        pauseBtn.setAttribute(
          'aria-label',
          playing ? pauseBtn.getAttribute('data-pause-label') : pauseBtn.getAttribute('data-play-label')
        );
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(activeIndex - 1);
        if (playing) start();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(activeIndex + 1);
        if (playing) start();
      });
    }
    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        setPlaying(!playing);
      });
    }

    render();
    setPlaying(wantsAutorotate);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-announcement-bar]').forEach(initAnnouncementBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
